import axiosInstance from '../../../../common/axios.service';
import {ADD_STATION, UPDATE_STATION} from './stations.type';
import type FILTERS from '../../../../common/filters.type';

const stationsList = (values: FILTERS) => {
  return axiosInstance.get('station/', {params: values}).then((response) => {
    return response;
  });
};
const authStationsList = (values: FILTERS) => {
  return axiosInstance.get('employeestation/authstation', {params: values}).then((response) => {
    return response;
  });
};

const addStation = (values: ADD_STATION) => {
  return axiosInstance.post('station', values).then((response) => {
    return response;
  });
};

const updateStation = (values: {id: number; payload: UPDATE_STATION}) => {
  return axiosInstance.put(`station/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const stationsService = {
  stationsList,
  addStation,
  updateStation,
  authStationsList,
};

export default stationsService;
